import "./Conditions.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import GirlNamesStartingWithA from "./sections/GirlNamesStartingWithA";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ConditionsPage() {
  return <div>
      <Header />
      <Hero />
      <GirlNamesStartingWithA />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}